import { render, staticRenderFns } from "./HtmlBlock.dynamic.vue?vue&type=template&id=265b351c&"
import script from "./HtmlBlock.dynamic.vue?vue&type=script&lang=js&"
export * from "./HtmlBlock.dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports